import type { ReactNode } from "react";
import { toast as sonnerToast } from "sonner";

type NotifyVariant = "default" | "destructive";

export interface NotifyOptions {
  title?: ReactNode;
  description?: ReactNode;
  variant?: NotifyVariant;
}

function toText(value: ReactNode | undefined): string {
  if (value == null) return "";
  if (typeof value === "string" || typeof value === "number") return String(value);
  return "";
}

export const notify = {
  success(message: ReactNode, description?: ReactNode) {
    return sonnerToast.success(toText(message), {
      description: toText(description) || undefined,
    });
  },
  info(message: ReactNode, description?: ReactNode) {
    return sonnerToast.info(toText(message), {
      description: toText(description) || undefined,
    });
  },
  error(message: ReactNode, description?: ReactNode) {
    return sonnerToast.error(toText(message), {
      description: toText(description) || undefined,
    });
  },
  message(message: ReactNode, description?: ReactNode) {
    return sonnerToast.message(toText(message), {
      description: toText(description) || undefined,
    });
  },
  fromLegacy(options: NotifyOptions) {
    const title = options.title;
    const description = options.description;
    if (options.variant === "destructive") {
      return notify.error(title ?? "Error", description);
    }
    return notify.message(title ?? "", description);
  },
};
